/* eslint-disable no-console */
import React, { useContext } from "react";
import clsx from "clsx";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
// @ts-ignore
import SplitPane from "react-split-pane/lib/SplitPane";
// @ts-ignore
import Pane from "react-split-pane/lib/Pane";
import { Fade, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
// import { useSnackbar } from "notistack";

import {
  Sidebar,
  PageHeadDiv,
  PageBodyDiv,
  SearchConditionDrawer,
  AlertDialog,
  SearchUserGroupDefs,
  ScrollDialog,
  Delayed,
  DetailFileInfoDialog,
  DetailFileInfoDialogStateType,
  KeywordHighlighter,
} from "../../components";
import { VirtualFolderTreeContainer } from "./VirtualFolderTreeContainer";
import { VirtualFolderInfoPane } from "./VirtualFolderInfoPane";
import { VirtualFolderDisplayOptionPane } from "./VirtualFolderDisplayOptionPane";
import { VirtualFolderFilterInput } from "./VirtualFolderFilterInput";
import { VirtualFolderContentList } from "./content/VirtualFolderContentList";
import { VirtualFolderContentDetails } from "./content/VirtualFolderContentDetails";
import { VirtualFolderContentThumbnail } from "./content/VirtualFolderContentThumbnail";
import {
  TreeDataType,
  StructureType,
  InitializeTreeData,
  MergeTreeData,
  OtherTreeNodeName,
  IsCategoryNode,
} from "./model/TreeItemModel";
import {
  KeyWordsSearchResultType,
  SearchVFConditionType,
} from "./model/DocumentItemModel";
import { LayoutConst } from "../../constants";
import {
  AlertDialogData,
  SortTypeData,
  DocumentItemType,
  ContextMenuData,
  SearchConditionData,
} from "../../types";
import {
  AppConfig,
  BaseApi,
  DocumentsApi,
  VirtualFoldersApi,
  getSelfUser,
  useWindowSize,
  zenkaku2Hankaku,
  STSearchDispatchContext,
  virtualFolderContextData,
  VirtualFolderDispatchContext,
  VirtualFolderActionType,
  VirtualFolderContextData,
  searchConditionInitData,
  errorToStr,
  useColorProvider,
} from "../../helpers";
import { SearchKeywordHelper } from "../SearchPage/helpers/search-keyword-helper";
import { TreeDataHelper } from "./helpers/tree-data-helper";
import { VirtualFolderSynonymEditableWrapper } from "./VirtualFolderSynonymEditableWrapper";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainPane: {
      display: "flex",
      width: "100%",
      height: "100%",
    },
    leftPane: {
      height: "100%",
      minWidth: "30%",
    },
    leftTreeFilterPane: {
      marginTop: "0.25rem",
    },
    leftTreePane: {
      // marginTop: "0.25rem",
      height: "calc(100% - 24px - 24px - 8px)", // 実際の高さと異なりブラウザの高さが取得されるため、現物合わせで調整
    },
    rightPane: {
      // width: "100%",
      height: "100%",
      minWidth: "30%",
      marginLeft: "0.5rem",
      marginRight: "0.5rem",
    },
    rightContentFilterPane: {
      display: "flex",
      marginTop: "0.25rem",
      height: 30,
    },
    rightContentFilterPaneInput: {
      flexGrow: 1,
    },
    rightContentFilterPaneOpener: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    rightInfoPane: {},
    rightDisplayOptionPane: {
      marginTop: "0.25rem",
    },
    synonym: {
      marginTop: "0.25rem",
    },
    bodyContent: {
      width: "100%",
      // backgroundColor: "#FFDDFF",
      flexGrow: 1,
      // padding: theme.spacing(2),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: -LayoutConst.searchConditionDrawer.width,
      // 右側ドロワーが閉じているとき、
      // 表示上は見えないが検索結果にドロワーが被ってしまい、
      // ツールチップが表示できないため z-index を設定する
      zIndex: 10,
    },
    bodyContentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 0,
    },
    bodyDrawer: {
      width: LayoutConst.searchConditionDrawer.width,
      flexShrink: 0,
    },
    bodySubcontainer: {
      display: "flex",
      width: "100%",
      height: "100%",
    },
    searchPaneRight: {
      //
    },
    displayOptionPane: {
      marginTop: "0.5rem",
    },
    resultPane: {
      marginTop: "0.5rem",
    },
    openButton: {
      color: theme.palette.text.secondary,
    },
    // キーワードハイライト
    highlight: {
      background: "yellow",
    },
  })
);

/** コンテキストメニュー マウスポインタ一 */
const contextMenuInitData: ContextMenuData = { mouseX: null, mouseY: null };

//------------------------------
// パネル開閉用

/** 展開パネルグループ情報定義 */
type TreePanelGroup = {
  id: number;
  name: string;
  expanded: boolean;
  size: string;
};

/** パネルサイズ（文字列）を数値に変換する */
function convertSize(size: string): number {
  const tokens = size.match(/([0-9]+)([px]*)/);
  if (tokens === null) {
    return 0;
  }
  const value = tokens[1];
  return +value;
}

/** 仮想フォルダーツリーフィルター処理 */
function filterTreeStructure(treeData: TreeDataType[], text: string) {
  const filter = zenkaku2Hankaku(text).toLowerCase();

  // 名称が一致する場合に表示
  treeData.forEach(t => {
    // 表示するパス
    let displayPath: string[] = [];

    t.structure.forEach(s => {
      const taraget = s;
      const name = zenkaku2Hankaku(taraget.name).toLowerCase();
      if (name.indexOf(filter) >= 0) {
        const paths: string[] = taraget.path.split("/").map((_p, idx, ary) => {
          // 先頭から現在要素までを切り出す
          const pathOfPart = ary.slice(0, idx + 1);
          // 先頭から現在要素までのパスを作る([分類1, 分類1/分類2, 分類1/分類2/分類3])
          return pathOfPart.reduce(
            (preVal, curVal) => (preVal ? `${preVal}/${curVal}` : curVal),
            ""
          );
        });
        displayPath = displayPath.concat(paths);
        // 重複をはじく
        displayPath = Array.from(new Set(displayPath));
      }
    });

    t.structure.forEach(s => {
      const taraget = s;
      if (displayPath.includes(s.path)) {
        taraget.isDisplaySelfOnFilter = true;
      } else {
        taraget.isDisplaySelfOnFilter = false;
      }
    });
  });
}

/** 検索キーワード取得処理（解析後 同義語含む） */
export function getFlatSearchKeywords(
  keyWordsSearchResult: KeyWordsSearchResultType | null
) {
  let keywords: string[] = [];
  if (keyWordsSearchResult && keyWordsSearchResult.search_keywords.length > 0) {
    keywords = SearchKeywordHelper.flattenSearchKeywords(
      keyWordsSearchResult.search_keywords,
      true
    );
  }
  return keywords;
}

interface Props {
  isAdmin?: boolean
}

/** 仮想フォルダ―画面 */
export function VirtualFolderPage(props: Props) {
  const { isAdmin = false } = props;

  const classes = useStyles();
  // const { closeSnackbar } = useSnackbar();
  const getColor = useColorProvider();
  const user = getSelfUser();
  const vfContext = useContext(virtualFolderContextData);
  const vfDispatch = useContext(VirtualFolderDispatchContext);
  const stDispatch = useContext(STSearchDispatchContext);

  // 検索後のドキュメント
  const [
    documentItems,
    setDocumentItems,
  ] = React.useState<KeyWordsSearchResultType | null>(null);

  // フィルタ後のドキュメント
  const [filterdDocumentItems, setFilterdDocumentItems] = React.useState<
    DocumentItemType[]
  >([]);

  // ソート後（フィルタも済）のドキュメント
  const [sortedDocumentItems, setSortedDocumentItems] = React.useState<
    DocumentItemType[]
  >([]);

  //------------------------------
  // アラートダイアログ
  // [State]
  const [alertDialogData, setAlertDialogData] = React.useState<AlertDialogData>(
    {
      open: false,
      title: "",
      message: "",
    }
  );

  //------------------------------
  // 絞り込み条件
  const [conditions, setConditions] = React.useState<SearchVFConditionType>({
    fileFilter: "",
    conditions: searchConditionInitData,
  });

  // 絞り込み条件ユーザグループ初期値
  const [userGroupDefsState] = React.useState<SearchUserGroupDefs>({
    defs: [],
    data: {},
    enabled: false,
    update: false,
  });

  // [Handler]
  /** 絞り込み条件の変更ハンドラ */
  const handleConditionChange = (newConditions: SearchConditionData) => {
    setConditions({ ...conditions, conditions: newConditions });
  };

  //------------------------------
  // Content
  // [State]
  const [contentDisplayMode, setContentDisplayMode] = React.useState<
    "details" | "list" | "thumbnail"
  >("details");

  //------------------------------
  // 検索結果コンテキストメニュー
  // [State]
  const [dataIndex, setDataIndex] = React.useState<null | number>(null);
  const [contextMenuData, setContextMenuData] = React.useState<ContextMenuData>(
    contextMenuInitData
  );

  // [Handler]
  const handleContextMenuClose = () => {
    setContextMenuData(contextMenuInitData);
  };

  // プレビューダイアログ
  const [previewDialogData, setPreviewDialogData] = React.useState<{
    open: boolean;
    title: React.ReactNode;
    content: string;
  }>({
    open: false,
    title: <></>,
    content: "",
  });

  const [
    openDetailFileInfoDialog,
    setOpenDetailFileInfoDialog,
  ] = React.useState<boolean>(false);

  const [
    detailFileInfoDialogState,
    setDetailFileInfoDialogState,
  ] = React.useState<DetailFileInfoDialogStateType>({
    title: "",
    sourceType: "",
    fileName: "",
    fileType: "",
    filePath: "",
    dirPath: "",
    url: "",
    contentText: "",
    thumbnail: "",
    createDate: "",
    updateDate: "",
  });

  const handleDetailFileInfoDialogClose = () => {
    setOpenDetailFileInfoDialog(false);
  };

  const handleContextMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const index = event.currentTarget.id.split("-")[1];
    setDataIndex(Number(index));
    setContextMenuData({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
  };

  //------------------------------
  // ソート
  // [State]
  const [sortTypeData, setSortState] = React.useState<SortTypeData>({
    item: "filename",
    order: true,
  });

  // ファイル種類の並び順の定義
  const fileTypeSortValue: { [key: string]: number } = {
    PDF: 1,
    ワード: 2,
    エクセル: 3,
    パワーポイント: 4,
    テキスト: 5,
  };

  // [HP稼働]: electronからの修正(不要処理削除)
  // ソート適用
  // const sortItems = (docItems: DocumentItemType[], sortProps: SortTypeData) => {
  //   if (docItems) {
  //     let items = docItems;

  //     if (sortProps.item === "filename") {
  //       if (sortProps.order === true) {
  //         items = items.sort((a, b) => {
  //           if (a.filename.toLowerCase() < b.filename.toLowerCase()) return -1;
  //           if (a.filename.toLowerCase() > b.filename.toLowerCase()) return 1;
  //           return 0;
  //         });
  //       } else if (sortProps.order === false) {
  //         items = items.sort((a, b) => {
  //           if (a.filename.toLowerCase() > b.filename.toLowerCase()) return -1;
  //           if (a.filename.toLowerCase() < b.filename.toLowerCase()) return 1;
  //           return 0;
  //         });
  //       }
  //     } else {
  //       // ファイル名以外の並べ替えでは２番目の並びをファイル名/昇順にするので、まずこれでソートしてから選択した方法でソートする
  //       items = items.sort((a, b) => {
  //         if (a.filename.toLowerCase() < b.filename.toLowerCase()) return -1;
  //         if (a.filename.toLowerCase() > b.filename.toLowerCase()) return 1;
  //         return 0;
  //       });

  //       if (sortProps.item === "filetype") {
  //         // ファイル種類の並び順は検索条件のアイコンの並びと合わせる
  //         if (sortProps.order === true) {
  //           items = items.sort((a, b) => {
  //             if (
  //               fileTypeSortValue[a.file_type] < fileTypeSortValue[b.file_type]
  //             )
  //               return -1;
  //             if (
  //               fileTypeSortValue[a.file_type] > fileTypeSortValue[b.file_type]
  //             )
  //               return 1;
  //             return 0;
  //           });
  //         } else if (sortProps.order === false) {
  //           items = items.sort((a, b) => {
  //             if (
  //               fileTypeSortValue[a.file_type] > fileTypeSortValue[b.file_type]
  //             )
  //               return -1;
  //             if (
  //               fileTypeSortValue[a.file_type] < fileTypeSortValue[b.file_type]
  //             )
  //               return 1;
  //             return 0;
  //           });
  //         }
  //       } else if (sortProps.item === "source_type") {
  //         if (sortProps.order === true) {
  //           items = items.sort((a, b) => {
  //             if (a.source_type < b.source_type) return -1;
  //             if (a.source_type > b.source_type) return 1;
  //             return 0;
  //           });
  //         } else if (sortProps.order === false) {
  //           items = items.sort((a, b) => {
  //             if (a.source_type > b.source_type) return -1;
  //             if (a.source_type < b.source_type) return 1;
  //             return 0;
  //           });
  //         }
  //       } else if (sortProps.item === "folder") {
  //         if (sortProps.order === true) {
  //           items = items.sort((a, b) => {
  //             if (a.dirpath.toLowerCase() < b.dirpath.toLowerCase()) return -1;
  //             if (a.dirpath.toLowerCase() > b.dirpath.toLowerCase()) return 1;
  //             return 0;
  //           });
  //         } else if (sortProps.order === false) {
  //           items = items.sort((a, b) => {
  //             if (a.dirpath.toLowerCase() > b.dirpath.toLowerCase()) return -1;
  //             if (a.dirpath.toLowerCase() < b.dirpath.toLowerCase()) return 1;
  //             return 0;
  //           });
  //         }
  //       } else if (sortProps.item === "create_datetime") {
  //         if (sortProps.order === true) {
  //           items = items.sort((a, b) => {
  //             if (a.create_date < b.create_date) return -1;
  //             if (a.create_date > b.create_date) return 1;
  //             return 0;
  //           });
  //         } else if (sortProps.order === false) {
  //           items = items.sort((a, b) => {
  //             if (a.create_date > b.create_date) return -1;
  //             if (a.create_date < b.create_date) return 1;
  //             return 0;
  //           });
  //         }
  //       } else if (sortProps.item === "update_datetime") {
  //         if (sortProps.order === true) {
  //           items = items.sort((a, b) => {
  //             if (a.update_date < b.update_date) return -1;
  //             if (a.update_date > b.update_date) return 1;
  //             return 0;
  //           });
  //         } else if (sortProps.order === false) {
  //           items = items.sort((a, b) => {
  //             if (a.update_date > b.update_date) return -1;
  //             if (a.update_date < b.update_date) return 1;
  //             return 0;
  //           });
  //         }
  //       }
  //     }

  //     setDataIndex(null);
  //     setSortedDocumentItems(items);
  //   }
  // };

  // [HP稼働]: electronからの修正(不要処理削除)
  // // [Handler]
  // const handleSortChange = (event: React.ChangeEvent<{ value: unknown }>) => {
  //   const sortVal = event.target.value as string;
  //   let sortItem = "";
  //   let sortOrder = true;
  //   if (sortVal) {
  //     // eslint-disable-next-line prefer-destructuring
  //     sortItem = sortVal.split("-")[0];
  //     sortOrder = sortVal.split("-")[1] === "true";
  //   }
  //   // ソート状態を保存
  //   const sortStateVal = { item: sortItem, order: sortOrder };
  //   setSortState(sortStateVal);
  //   // setState直後はStateに反映されていない可能性があるのでsortStateValを使用
  //   sortItems(filterdDocumentItems, sortStateVal);
  // };

  // // [Handler]
  // const handleContentDisplayModeChange = (
  //   _event: React.MouseEvent<HTMLElement>,
  //   newContentDisplayMode: "details" | "list" | "thumbnail"
  // ) => {
  //   setContentDisplayMode(newContentDisplayMode);
  // };

  // /** 指定日付を日付の絞り込み検索条件に変換する */
  // const convertToConditionDate = (date: Date, max: boolean) => {
  //   return new Date(
  //     date.getFullYear(),
  //     date.getMonth(),
  //     date.getDate(),
  //     max ? 23 : 0,
  //     max ? 59 : 0,
  //     max ? 59 : 0,
  //     max ? 999 : 0
  //   );
  // };

  /** 文書フィルタ適用 */
  React.useEffect(() => {
    let cleanedUp = false;

    if (documentItems) {
      const filter = conditions;

      // ファイルタイプ全許可
      const ngFileType = Object.values(filter.conditions.fileTypeData).filter(
        value => value === false
      );
      // 全て対象か、全て対象外
      const allowAllFileType =
        ngFileType.length === 0 ||
        ngFileType.length ===
        Object.keys(filter.conditions.fileTypeData).length;

      // ファイルタイプ条件
      const allowFilterType: string[] = [];
      if (!allowAllFileType) {
        // TODO: どこかに定数定義または変換関数を作成する
        if (filter.conditions.fileTypeData.txt)
          allowFilterType.push("テキスト");
        if (filter.conditions.fileTypeData.doc) allowFilterType.push("ワード");
        if (filter.conditions.fileTypeData.xls)
          allowFilterType.push("エクセル");
        if (filter.conditions.fileTypeData.ppt)
          allowFilterType.push("パワーポイント");
        if (filter.conditions.fileTypeData.pdf) allowFilterType.push("PDF");
      }

      // [HP稼働]: electronからの修正(不要処理削除)
      // // 取得元タイプ全許可
      // const ngSourceType = Object.values(
      //   filter.conditions.sourceTypeData
      // ).filter(value => value === false);
      // // 全て対象か、全て対象外
      // const allowAllSourceType =
      //   ngSourceType.length === 0 ||
      //   ngSourceType.length ===
      //     Object.keys(filter.conditions.sourceTypeData).length;

      // // 取得元タイプ条件
      // const allowFilterSourceType: string[] = [];
      // if (!allowAllSourceType) {
      //   // TODO: どこかに定数定義または変換関数を作成する
      //   if (filter.conditions.sourceTypeData.nas)
      //     allowFilterSourceType.push("NAS");
      //   if (filter.conditions.sourceTypeData.web)
      //     allowFilterSourceType.push("WEB");
      // }

      // // 日付
      // let fromD: Date | null = null;
      // let endD: Date | null = null;

      // // 詳細指定
      // if (filter.conditions.dateTypeData.dateDetailMode) {
      //   fromD = filter.conditions.dateTypeData.selectedFromDate
      //     ? convertToConditionDate(
      //         filter.conditions.dateTypeData.selectedFromDate,
      //         false
      //       )
      //     : null;
      //   endD = filter.conditions.dateTypeData.selectedToDate
      //     ? convertToConditionDate(
      //         filter.conditions.dateTypeData.selectedToDate,
      //         true
      //       )
      //     : null;
      // } else {
      //   // 簡易指定
      //   const now = new Date();
      //   fromD = convertToConditionDate(now, false);
      //   endD = convertToConditionDate(now, true);

      //   // １週間以内: 11
      //   if (filter.conditions.dateTypeData.dateValue === "11") {
      //     fromD.setDate(fromD.getDate() - 7);
      //   }
      //   // １か月以内: 12
      //   else if (filter.conditions.dateTypeData.dateValue === "12") {
      //     fromD.setMonth(fromD.getMonth() - 1);
      //   }
      //   // ３か月以内: 13
      //   else if (filter.conditions.dateTypeData.dateValue === "13") {
      //     fromD.setMonth(fromD.getMonth() - 3);
      //   }
      //   // １年以内: 14
      //   else if (filter.conditions.dateTypeData.dateValue === "14") {
      //     fromD.setFullYear(fromD.getFullYear() - 1);
      //   } else {
      //     fromD = null;
      //     endD = null;
      //   }
      // }

      // // 日付未指定時はどんな日付も含まれるようにする
      // const fromDate = fromD ? fromD.getTime() : 0;
      // const endDate = endD ? endD.getTime() : Number.MAX_SAFE_INTEGER;

      // // 日付種類
      // let checkDate = true;
      // let isCreateDate = false;
      // // 作成日時: 10
      // if (filter.conditions.dateTypeData.dateType === "10") {
      //   isCreateDate = true;
      //   // 更新日時: 20
      // } else if (filter.conditions.dateTypeData.dateType === "20") {
      //   isCreateDate = false;
      // } else {
      //   checkDate = false;
      // }

      // ファイル名
      // 全角->半角
      let filterName = zenkaku2Hankaku(filter.fileFilter);
      // 小文字化
      filterName = filterName.toLowerCase();

      // 絞り込む
      const filterd = documentItems.search_list.filter(d => {
        let match = true;
        // ファイルタイプ
        if (match && !allowAllFileType) {
          match = allowFilterType.includes(d.file_type);
        }
        // [HP稼働]: electronからの修正(不要処理削除)
        // // 取得元タイプ
        // if (match && !allowAllSourceType) {
        //   match = allowFilterSourceType.includes(d.source_type);
        // }
        // // 日付範囲
        // if (match && checkDate) {
        //   if (isCreateDate) {
        //     const target = Date.parse(d.create_date);
        //     match = fromDate <= target && target <= endDate;
        //   } else {
        //     const target = Date.parse(d.update_date);
        //     match = fromDate <= target && target <= endDate;
        //   }
        // }
        // ファイル名
        if (match && filterName !== "") {
          const targetFilename = zenkaku2Hankaku(d.filename).toLowerCase();
          match = targetFilename.indexOf(filterName) >= 0;
        }
        return match;
      });

      // 更新
      if (filterd) {
        if (!cleanedUp) {
          setFilterdDocumentItems(filterd);
          // [HP稼働]: electronからの修正(不要処理削除&setSortedDocumentItems追加)
          // // ソート
          // sortItems(filterd, sortTypeData);
          setSortedDocumentItems(filterd);
        }
      }
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [conditions, documentItems]);

  //------------------------------
  // Content filter
  // [State]

  // 文書フィルタ
  const [contentFilterText, setContentFilterText] = React.useState<string>("");

  // [Handler]
  /** 文書フィルタ変更ハンドラ */
  const contentFilterHandleSubmit = (text: string) => {
    setContentFilterText(text);
    setConditions({ ...conditions, fileFilter: text });
  };

  //------------------------------
  // Content Search
  // [State]

  // 文書の検索キーワード
  const [keywords, setKeywords] = React.useState<{
    keywords: string[];
    configId: number;
    excludes: string[];
  }>({ keywords: [], configId: -1, excludes: [] });

  // 文書階層のパンくず
  const [breadcrumbs, setBreadcrumbs] = React.useState<{
    path: string;
    configId: number;
    excludes: string[];
  }>({ path: "", configId: -1, excludes: [] });

  /**
   * 文書データを取得
   * [API [GET document/keywords]]
   */
  React.useEffect(() => {
    let cleanedUp = false;

    // ユーザーグループIDを取得
    const userGroupIds: number[] = [];
    user?.userusergroup_set?.forEach(uug => {
      if (uug.user_group.virtual_folder_config === keywords.configId) {
        userGroupIds.push(uug.user_group.id)
      }
    }
    );

    if (keywords.keywords.length !== 0 || keywords.excludes.length !== 0) {
      const vfConfig = AppConfig.get("virtualFolders");

      const fetchData = async () => {
        try {
          const result = await DocumentsApi.keyWordsSearch(
            keywords.keywords,
            userGroupIds,
            keywords.excludes,
            1
          );

          // 検索キーワード（編集・参照）
          const searchKeywordsSynonyms = result.data.search_keywords_synonyms;

          const allResult = result.data;
          if (!cleanedUp) {
            setDocumentItems(allResult);
          }

          // 次ページ以降を再帰取得
          if (allResult.total_info.next_page_url) {
            BaseApi.recursive(
              allResult.total_info.next_page_url,
              (nextResult: any) => {
                allResult.search_list = allResult.search_list.concat(
                  nextResult.data.search_list
                );
                if (!cleanedUp) {
                  // TODO: 一旦反映しているつもりだが、副作用が終わらなければ、再レンダーはされないので結局全件取得してから表示している？
                  setDocumentItems({ ...allResult });
                }

                // 取得件数上限
                if (
                  allResult.search_list.length >= vfConfig.documentsShowLimit
                ) {
                  return null;
                }
                return nextResult.data.total_info.next_page_url;
              }
            );
          }

          if (vfDispatch) {
            vfDispatch({
              type: VirtualFolderActionType.UPDATE,
              payload: {
                ...vfContext,
                synonym: {
                  updateStatus: "ready",
                },
                editableSearchKeywords: SearchKeywordHelper.toEditableSearchKeywords(
                  searchKeywordsSynonyms,
                  false
                ),
              },
            });
          }
        } catch (error: any) {
          if (!cleanedUp) {
            setAlertDialogData({
              open: true,
              title: "エラー",
              message: errorToStr(error),
            });
          }
        }
      };
      fetchData();
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [keywords]);

  /**
   * 重要語を持つ文書を検索
   * その他フォルダ―を選択した場合は、兄弟ノードの重要語を除外する
   */
  const searchKeyWords = (path: string, configId: number, excludes: string[]) => {
    if (!path || configId === -1) return;
    let newPath = path;

    // 念のため先頭に/がついていたら削除
    if (newPath[0] === "/") {
      newPath = newPath.slice(1, newPath.length - 1);
    }

    // 検索条件をコンテキストにセットする
    if (vfDispatch) {
      vfDispatch({
        type: VirtualFolderActionType.UPDATE,
        payload: {
          path: newPath,
          excludes,
        } as VirtualFolderContextData,
      });
    } else {
      return;
    }

    const paths = newPath.split("/");

    // 第一階層はカテゴリなので削除する
    paths.shift();
    if (excludes.length >= 0 && paths[paths.length - 1] === OtherTreeNodeName) {
      // その他を削除
      paths.pop();
    }

    setKeywords({ keywords: paths, configId, excludes });
  };

  /** パンくずリストの重要語を指定した検索 */
  const handleClickBreadcrumbs = (path: string, configId: number, excludes?: string[]) => {
    searchKeyWords(path, configId, excludes || []);
  };

  /** 初期表示時にコンテキストで受け取ったパラメータで検索 */
  React.useEffect(() => {
    let cleanedUp = false;

    if (vfContext.path && vfContext.virtualFolderConfigId) {
      if (!cleanedUp) {
        setBreadcrumbs({
          path: vfContext.path,
          configId: vfContext.virtualFolderConfigId,
          excludes: vfContext.excludes || [],
        });
        searchKeyWords(vfContext.path, vfContext.virtualFolderConfigId, vfContext.excludes || []);
      }
    }

    // 同義語コンテキストの初期化
    // if (synonymDispatch) {
    //   synonymDispatch({
    //     type: SynonymsEditActionType.CLEAR,
    //   });
    // }

    return function cleanup() {
      cleanedUp = true;
    };
  }, []);

  //------------------------------
  // 仮想フォルダー設定関連

  // [State]
  // 仮想フォルダー設定
  const [treeData, setTreeData] = React.useState<TreeDataType[]>([]);

  // 仮想フォルダー設定(更新用)
  const [
    updateTreeData,
    setUpdateTreeData,
  ] = React.useState<TreeDataType | null>(null);

  // [State操作関数]

  /** 仮想フォルダ―情報取得(仮想フォルダ―設定ID指定) */
  const getTreeDataById = (id: number | undefined) => {
    return treeData.find(t => t.virtual_folder_config_id === id);
  };

  /** ローカルの仮想フォルダ―情報取得(仮想フォルダ―設定ID指定) */
  const getLocalTreeDataById = (id: number) => {
    const localTreeData = TreeDataHelper.loadLocalTreeData();
    if (localTreeData) {
      return localTreeData.find(t => t.virtual_folder_config_id === id);
    }
    return InitializeTreeData(id);
  };

  /** 仮想フォルダ―情報のsetState(仮想フォルダ―設定ID指定) */
  const setTreeDataById = (
    id: number | undefined,
    structure: StructureType[] | undefined,
    expandedNode: string[] | undefined,
    isDisplayAll: boolean | undefined,
    update: boolean
  ) => {
    const index = treeData.findIndex(
      tree => tree.virtual_folder_config_id === id
    );
    if (index >= 0) {
      const newTree = treeData[index];
      if (structure) {
        // eslint-disable-next-line no-param-reassign
        newTree.structure = structure;
      }
      if (expandedNode) {
        // eslint-disable-next-line no-param-reassign
        newTree.expandedNode = expandedNode;
      }
      if (isDisplayAll !== undefined) {
        // eslint-disable-next-line no-param-reassign
        newTree.isDisplayAll = isDisplayAll;
      }
      setTreeData(treeData.slice());
      TreeDataHelper.saveLocalTreeData(treeData.slice());
      if (update) {
        setUpdateTreeData(newTree);
      }
    }
  };

  // [Handler]

  /** 仮想フォルダ―ツリーのノードクリックアクション */
  const handleClickNode = (
    event: React.MouseEvent<HTMLElement>,
    nodeId: string,
    configId: number,
    excludes?: string[]
  ) => {
    event.preventDefault();
    event.stopPropagation();
    if (IsCategoryNode(nodeId)) {
      return;
    }
    setBreadcrumbs({ path: nodeId, configId, excludes: excludes || [] });
    searchKeyWords(nodeId, configId, excludes || []);
  };

  //------------------------------
  // Tree filter
  // [State]

  // 仮想フォルダツリーのフィルタ（フィルター実行中のテキスト）
  const [treeFilterText, setTreeFilterText] = React.useState<string>("");

  // [Handler]
  /** 仮想フォルダのフィルタハンドラ */
  const treeFilterHandleSubmit = (text: string) => {
    setTreeFilterText(text);
    filterTreeStructure(treeData, text);
    setTreeData(treeData.slice());
  };

  //------------------------------
  // Tree Panel
  // [State]

  // リサイズ後のWindowサイズ
  const [, windowHeight] = useWindowSize();
  // 仮想フォルダの横方向のサイズ
  const [vfPanelWidth, setVFPanelWidth] = React.useState<string>("360px");

  // 仮想フォルダのユーザグループ・ユーザの配列
  const [treePanelGroup, setTreePanelGroup] = React.useState<TreePanelGroup[]>(
    []
  );

  // [Ref]
  // 仮想フォルダー(グループ・ユーザ)を包含する親要素への参照（サイズ変更用）
  const refTreeSplitPane = React.useRef<any>(null);

  // [Handler]

  /** 仮想フォルダの横幅サイズ変更ハンドラ */
  const treeFilterHandleWidthChange = (newSize: any) => {
    // 一つ目が幅
    setVFPanelWidth(newSize[0]);
  };

  /** 仮想フォルダ全体のサイズ変更ハンドラ */
  const treeFilterHandleSizeChange = (newSize: any) => {
    // 実体はstring[]だが、Type定義がstringなので一旦anyで受け、string[]に変換する
    const newSizes = newSize.map((s: string) => s);

    treePanelGroup.forEach((g, index) => {
      // eslint-disable-next-line no-param-reassign
      g.size = newSizes[index];
    });

    // 配列全体を更新
    setTreePanelGroup(treePanelGroup.slice());
  };

  /** 仮想フォルダ毎のサイズ変更ハンドラ */
  const treeFilterHandleExpandedChange = (id: number, newExpanded: boolean) => {
    // TODO: あとでSplitPane配下をコンポーネント化してそこで処理する
    // console.log("サイズ変更");

    const curGrp = treePanelGroup.find(g => g.id === id);
    if (!curGrp) return;

    const curSize = curGrp.size;
    const minSize = `${LayoutConst.expantionPanel.summary.height}px`;

    // パネルの全体高さ
    let panelHeight = 0;
    if (refTreeSplitPane && refTreeSplitPane.current) {
      panelHeight = Number.parseInt(
        refTreeSplitPane.current.getBoundingClientRect().height,
        10
      );
    }
    // リサイザー(1px)の分を差し引く
    panelHeight -= treePanelGroup.length - 1;

    if (newExpanded) {
      let otherHeight = 0;
      // 開いているところは基準サイズとし
      treePanelGroup.forEach(g => {
        if (g.id !== id) {
          if (g.expanded) {
            // 開いているところは基準サイズ
            // eslint-disable-next-line no-param-reassign
            g.size = `${LayoutConst.virtualFolderTree.group.minHeight}px`;
            otherHeight += LayoutConst.virtualFolderTree.group.minHeight;
          } else {
            // 閉じているところは最小サイズ
            // eslint-disable-next-line no-param-reassign
            g.size = `${LayoutConst.expantionPanel.summary.height}px`;
            otherHeight += LayoutConst.expantionPanel.summary.height;
          }
        }
      });
      // 残りを自分のサイズとする
      let newHeight = panelHeight - otherHeight;
      // 計算に失敗しても最低限の高さを維持
      if (newHeight < LayoutConst.virtualFolderTree.group.minHeight) {
        newHeight = LayoutConst.virtualFolderTree.group.minHeight;
      }
      curGrp.size = `${newHeight}px`;
    } else {
      // 操作した以外の、開いているユーザーグループを下から探す
      let targetGrp = Array.from(treePanelGroup)
        .reverse()
        .find(g => g.id !== id && g.expanded);
      // 全部閉じていれば一番下を採用
      if (!targetGrp) {
        targetGrp = treePanelGroup[treePanelGroup.length - 1];
      }

      if (targetGrp.id === id) {
        // 自分自身なら今のサイズのまま
      } else {
        const curHeight = convertSize(curSize);
        const targetSize = targetGrp.size;
        const targetHeight = convertSize(targetSize);

        // 自分のサイズをタイトル高さにする
        curGrp.size = minSize;
        // 残りのグループのサイズ
        const remainingHeight = panelHeight - curHeight - targetHeight;
        // パネル高さから残りのグループと、今クローズした高さを引く
        let newHeight =
          panelHeight -
          remainingHeight -
          LayoutConst.expantionPanel.summary.height;
        // 計算に失敗しても最低限の高さを維持
        if (newHeight < LayoutConst.virtualFolderTree.group.minHeight) {
          newHeight = LayoutConst.virtualFolderTree.group.minHeight;
        }
        targetGrp.size = `${newHeight}px`;
      }
    }

    curGrp.expanded = newExpanded;
    // 配列全体を更新
    setTreePanelGroup(treePanelGroup.slice());
  };

  /** リサイズに合わせて伸縮させる */
  React.useEffect(() => {
    // TODO: SplitePaneである程度自動で調整されるが、理想的な形ではない

    if (treePanelGroup.length === 0) return;
    // console.log("リサイズ");

    // パネルの全体高さ
    if (refTreeSplitPane && refTreeSplitPane.current) {
      // TODO:
    }

    // console.log(panelHeight);
    // 開いているツリーを探す

    // 開いているツールのサイズを大きくする
    // 複数開いている場合は一番下を大きくする

    // 開いているツールのサイズを小さくする
    // 複数開いている場合は均等に小さくする
    // 最小サイズ以下にはならない
  }, [windowHeight, treePanelGroup]);

  //------------------------------
  // コンテキスト操作

  // プレビュー
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleOpenPreviewDialog = (_event: React.MouseEvent<HTMLElement>) => {
    if (dataIndex == null || sortedDocumentItems == null) {
      return;
    }
    const data = sortedDocumentItems[dataIndex];
    DocumentsApi.detail(data.id)
      .then((response: any) => {
        setPreviewDialogData({
          open: true,
          title: response.data.doc.filename,
          content: response.data.doc.contents,
        });
        setContextMenuData(contextMenuInitData);
        return true;
      })
      .catch(error => {
        setAlertDialogData({
          open: true,
          title: "エラー",
          message: errorToStr(error),
        });
        setContextMenuData(contextMenuInitData);
      });
  };

  // 詳細情報表示
  const handleOpenDetailFileInfoDialog = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _event: React.MouseEvent<HTMLElement>
  ) => {
    if (dataIndex == null || sortedDocumentItems == null) {
      return;
    }
    const data = sortedDocumentItems[dataIndex];
    setDetailFileInfoDialogState({
      title: "詳細情報",
      fileName: data.filename,
      fileType: data.file_type,
      sourceType: data.source_type,
      filePath: data.filepath,
      dirPath: data.dirpath,
      url: data.url,
      contentText: data.first_str,
      thumbnail: data.thumb,
      createDate: data.create_date,
      updateDate: data.update_date,
    });

    setOpenDetailFileInfoDialog(true);
    setContextMenuData(contextMenuInitData);
  };

  //------------------------------
  // [HP稼働]: electronからの修正(不要処理削除)
  // // ファイルパス取得
  // const getFilePathFull = (filePath: string, hostName: string) => {
  //   // ローカルの場合はファイルパスをそのまま取得
  //   if (hostName === "localhost") {
  //     return filePath;
  //   }
  //   // hostnameからIPアドレスを取得
  //   const ip = hostName.split(":")[0];

  //   const filePathFull = `//${ip}/${filePath}`;
  //   return filePathFull;
  // };

  // [HP稼働]: electronからの修正(不要処理削除)
  // // アプリで開く
  // // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const handleOpenPath = (_event: React.MouseEvent<HTMLElement>) => {
  //   if (dataIndex == null || sortedDocumentItems == null) {
  //     return;
  //   }
  //   const data = sortedDocumentItems[dataIndex];
  //   if (data.source_type === "NAS") {
  //     const path = getFilePathFull(data.filepath, data.hostname);
  //     // ElectronAccessor.openPath(path.replace(/\//g, "\\"));
  //   } else {
  //     // ElectronAccessor.openExternal(data.url);
  //   }
  //   setContextMenuData(contextMenuInitData);
  // };

  // [HP稼働]: electronからの修正(不要処理削除)
  // // ファイルの場所を開く
  // const handleShowItemInFolder = () => {
  //   if (dataIndex == null || sortedDocumentItems == null) {
  //     return;
  //   }
  //   const data = sortedDocumentItems[dataIndex];
  //   const path = getFilePathFull(data.filepath, data.hostname);
  //   // [HP稼働]: electronからの修正
  //   // ElectronAccessor.showItemInFolder(path.replace(/\//g, "\\"));
  //   setContextMenuData(contextMenuInitData);
  // };

  // [HP稼働]: electronからの修正(不要処理削除)
  // // 類似検索
  // const history = useHistory();
  // const handleSTSearch = (
  //   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  //   _event: React.MouseEvent<HTMLElement, MouseEvent>
  // ) => {
  //   if (dataIndex == null || sortedDocumentItems == null) {
  //     return;
  //   }
  //   const data = sortedDocumentItems[dataIndex];
  //   if (stDispatch) {
  //     stDispatch({
  //       type: STSearchActionType.UPDATE,
  //       payload: {
  //         searchRequest: {
  //           id: data.id,
  //           filename: data.filename,
  //         },
  //       } as STSearchContextData,
  //     });
  //     // 類似検索画面に遷移
  //     history.push(UrlConst.member.similarityTextSearch);
  //   }
  // };

  // [Render]
  let contentPane;
  contentPane = (
    <VirtualFolderContentDetails
      items={sortedDocumentItems}
      itemIndex={dataIndex}
      contextMenuData={contextMenuData}
      handleClick={handleContextMenuClick}
      handleClose={handleContextMenuClose}
      handleOpenPreviewDialog={handleOpenPreviewDialog}
      handleOpenDetailFileInfoDialog={handleOpenDetailFileInfoDialog}
    />
  );
  // [HP稼働]: electronからの修正(不要処理削除)
  // if (contentDisplayMode === "list") {
  //   contentPane = (
  //     <VirtualFolderContentList
  //       items={sortedDocumentItems}
  //       itemIndex={dataIndex}
  //       contextMenuData={contextMenuData}
  //       handleClick={handleContextMenuClick}
  //       handleClose={handleContextMenuClose}
  //       handleOpenPreviewDialog={handleOpenPreviewDialog}
  //       handleOpenDetailFileInfoDialog={handleOpenDetailFileInfoDialog}
  //       // [HP稼働]: electronからの修正(不要処理削除)
  //       // handleOpenPath={handleOpenPath}
  //       // handleShowItemInFolder={handleShowItemInFolder}
  //       // handleSTSearch={handleSTSearch}
  //     />
  //   );
  // } else if (contentDisplayMode === "details") {
  //   contentPane = (
  //     <VirtualFolderContentDetails
  //       items={sortedDocumentItems}
  //       itemIndex={dataIndex}
  //       contextMenuData={contextMenuData}
  //       handleClick={handleContextMenuClick}
  //       handleClose={handleContextMenuClose}
  //       handleOpenPreviewDialog={handleOpenPreviewDialog}
  //       handleOpenDetailFileInfoDialog={handleOpenDetailFileInfoDialog}
  //       // [HP稼働]: electronからの修正(不要処理削除)
  //       // handleOpenPath={handleOpenPath}
  //       // handleShowItemInFolder={handleShowItemInFolder}
  //       // handleSTSearch={handleSTSearch}
  //     />
  //   );
  // } else if (contentDisplayMode === "thumbnail") {
  //   contentPane = (
  //     <VirtualFolderContentThumbnail
  //       items={sortedDocumentItems}
  //       itemIndex={dataIndex}
  //       contextMenuData={contextMenuData}
  //       handleClick={handleContextMenuClick}
  //       handleClose={handleContextMenuClose}
  //       handleOpenPreviewDialog={handleOpenPreviewDialog}
  //       handleOpenDetailFileInfoDialog={handleOpenDetailFileInfoDialog}
  //       // [HP稼働]: electronからの修正(不要処理削除)
  //       // handleOpenPath={handleOpenPath}
  //       // handleShowItemInFolder={handleShowItemInFolder}
  //       // handleSTSearch={handleSTSearch}
  //     />
  //   );
  // }

  //------------------------------
  // Page
  // [State]

  // 仮想フォルダ構造の更新
  const [
    doRefreshVirtualFoldersTree,
    setDoRefreshVirtualFoldersTree,
  ] = React.useState<boolean | null>(null);

  // サイズ初期化済み
  const refSizeInitialized = React.useRef<boolean>(false);
  // グループの縦幅初期値（計算済み値）
  const [initSize, setInitSize] = React.useState<string[]>([]);

  /** 初期サイズの計算 */
  React.useLayoutEffect(() => {
    // 最初のレンダリングで実施
    if (refSizeInitialized.current) return;
    refSizeInitialized.current = true;
    // console.log("初期サイズの計算");

    // パネルの全体高さ
    let panelHeight = 800; // 仮の初期値
    // 対象パネルの高さを取得
    if (refTreeSplitPane && refTreeSplitPane.current) {
      panelHeight = Number.parseInt(
        refTreeSplitPane.current.getBoundingClientRect().height,
        10
      );
    }

    // ユーザーグループの仮想フォルダ数
    const ugCount = user?.userusergroup_set?.length || 0;

    // リサイザー(1px)の分を差し引く
    panelHeight -= ugCount;
    // [HP稼働] フォルダ構造表示の修正
    const defaultHeight = Math.floor(panelHeight / ugCount);
    // const defaultHeight = Math.floor(panelHeight / (ugCount + 1));
    let sumHeight = 0;

    // ユーザーグループの仮想フォルダ
    [...Array(ugCount)].forEach(() => {
      sumHeight += defaultHeight;
      initSize.push(`${defaultHeight}px`);
    });

    // ユーザーの仮想フォルダ
    initSize.push(`${panelHeight - sumHeight}px`);

    // console.log(initSize);
    setInitSize(initSize.slice());
  });

  /** 初期データ取得（ユーザーグループ） */
  React.useEffect(() => {
    let cleanedUp = false;

    if (refSizeInitialized.current && initSize.length !== 0) {
      // console.log("初期データの取得");

      const fetchData = async () => {
        const groups: TreePanelGroup[] = [];

        // ユーザーグループの仮想フォルダIDを取得
        user?.userusergroup_set?.forEach((ug, index) => {
          groups.push({
            id: ug.user_group.virtual_folder_config,
            name: ug.user_group.name,
            expanded: true,
            size: initSize[index],
          });
        });

        // // ユーザーの仮想フォルダIDを取得
        // if (user?.virtual_folder_config?.id) {
        //   groups.push({
        //     id: user.virtual_folder_config.id,
        //     name: "個人",
        //     expanded: true,
        //     size: initSize[initSize.length - 1],
        //   });
        // }

        // 仮想フォルダ―の初期値作成（空データ）
        const initialTreeData = groups.map(g => InitializeTreeData(g.id));

        // ユーザーグループよりも先に空の配列を設定する
        if (!cleanedUp) {
          setTreeData(initialTreeData);
          setTreePanelGroup(groups);
          setDoRefreshVirtualFoldersTree(!doRefreshVirtualFoldersTree);
        }
      };
      fetchData();
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [initSize]);

  /**
   * 仮想フォルダ構造取得
   * [API [GET virtual_folders]]
   */
  React.useEffect(() => {
    let cleanedUp = false;

    if (doRefreshVirtualFoldersTree !== null) {
      // console.log("仮想フォルダ構造取得");

      const fetchData = async () => {
        const configIds: number[] = [];

        // ユーザグループとユーザの仮想フォルダID
        user?.userusergroup_set?.forEach(uug => {
          configIds.push(uug.user_group.virtual_folder_config);
        });
        if (user?.virtual_folder_config?.id) {
          configIds.push(user.virtual_folder_config.id);
        }

        Promise.all(
          configIds.map(async configId => {
            return VirtualFoldersApi.retrieve(configId);
          })
        )
          .then(vfs => {
            const virtualFolders = vfs.map((vf, index) => {
              if (Object.keys(vf.data).length === 0) {
                // 空なら新規
                return InitializeTreeData(configIds[index]);
              }
              // ローカル設定とマージ
              // 変更時に常にローカルに更新しているので、いつアプリを終了しても設定は最新状態
              return MergeTreeData(
                vf.data,
                getLocalTreeDataById(vf.data.virtual_folder_config_id as number)
              );
            });

            // 仮想フォルダ構造フィルター反映
            if (treeFilterText !== "") {
              filterTreeStructure(virtualFolders, treeFilterText);
            }

            if (!cleanedUp) {
              setTreeData(virtualFolders);
            }
            return true;
          })
          .catch(error => {
            // 失敗
            if (!cleanedUp) {
              setAlertDialogData({
                open: true,
                title: "エラー",
                message: errorToStr(error),
              });
            }
          });
      };
      fetchData();
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [doRefreshVirtualFoldersTree]);

  /**
   * 仮想フォルダ構造更新
   * [API [PUT virtual_folders]]
   */
  React.useEffect(() => {
    let cleanedUp = false;

    if (updateTreeData !== null) {
      // console.log("仮想フォルダ構造更新");

      const fetchData = async () => {
        try {
          const result = await VirtualFoldersApi.update(
            updateTreeData.virtual_folder_config_id,
            {
              structure: updateTreeData.structure.map(st => ({
                name: st.name,
                path: st.path,
              })),
              created_at: updateTreeData.created_at,
            }
          );

          // 現在のステートとマージして再描画
          const newTreeData = MergeTreeData(result.data, updateTreeData);

          // 更新
          const index = treeData.findIndex(
            t =>
              t.virtual_folder_config_id ===
              newTreeData.virtual_folder_config_id
          );
          treeData[index] = newTreeData;

          // 仮想フォルダ構造フィルター反映
          if (treeFilterText !== "") {
            filterTreeStructure(treeData, treeFilterText);
          }

          if (!cleanedUp) {
            setTreeData(treeData.slice());
          }
        } catch (error: any) {
          if (!cleanedUp) {
            setAlertDialogData({
              open: true,
              title: "エラー",
              message: errorToStr(error),
            });
          }
        }
      };
      fetchData();
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [updateTreeData]);

  /**
   * 仮想フォルダ構造・定期取得
   * [API [GET virtual_folders]]
   */
  React.useEffect(() => {
    let cleanedUp = false;

    // インターバル
    const vfConfig = AppConfig.get("virtualFolders");

    // 定期的に実行
    const id = setInterval(() => {
      if (!cleanedUp) {
        setDoRefreshVirtualFoldersTree(prevDo => !prevDo);
      }
    }, vfConfig.refreshInterval);

    // 終了処理
    return function cleanup() {
      clearInterval(id);
      cleanedUp = true;
    };
  }, []);

  //--------------------
  // コンポーネント
  return (
    <div className="main-container">
      {/* [HP稼働]: electronからの修正(不要処理削除) */}
      {/* <div className="left-container">
        <Sidebar />
      </div> */}
      <div className="right-container">
        <PageHeadDiv title="仮想フォルダー" />
        <PageBodyDiv>
          <div className={classes.bodySubcontainer}>
            <div
              className={clsx(classes.bodyContent, {
                [classes.bodyContentShift]: vfContext.openSearchConditionDrawer,
              })}
            >
              <SplitPane
                split="vertical"
                onChange={treeFilterHandleWidthChange}
              >
                <Pane
                  className={classes.leftPane}
                  initialSize="360x"
                  minSize="10%"
                  maxSize="50%"
                  size={vfPanelWidth}
                >
                  {/* Tree Filter */}
                  <div className={classes.leftTreeFilterPane}>
                    <VirtualFolderFilterInput
                      toolTipTitle={
                        treeFilterText !== ""
                          ? `「${treeFilterText}」で絞り込んでいます`
                          : `フォルダーをフィルター`
                      }
                      square
                      initialText={treeFilterText}
                      handleChange={treeFilterHandleSubmit}
                    />
                  </div>

                  {/* ツリー */}
                  <div className={classes.leftTreePane} ref={refTreeSplitPane}>
                    <SplitPane
                      split="horizontal"
                      onChange={treeFilterHandleSizeChange}
                    >
                      {treePanelGroup.map((g: TreePanelGroup) => (
                        <Pane
                          key={g.id}
                          initialSize="56px"
                          minSize={`${LayoutConst.expantionPanel.summary.height}px`}
                          maxSize="100%"
                          size={g.size}
                        >
                          <VirtualFolderTreeContainer
                            id={g.id}
                            title={g.name}
                            height={g.size}
                            expanded={g.expanded}
                            onChange={treeFilterHandleExpandedChange}
                            treeData={getTreeDataById(g.id) as TreeDataType}
                            getTreeDataById={getTreeDataById}
                            setTreeDataById={setTreeDataById}
                            handleClickNode={handleClickNode}
                            setAlertDialogData={setAlertDialogData}
                            isAdmin={isAdmin}
                          />
                        </Pane>
                      ))}
                    </SplitPane>
                  </div>
                </Pane>
                <div className={classes.rightPane}>
                  {/* Content Filter */}
                  <div className={classes.rightContentFilterPane}>
                    <VirtualFolderFilterInput
                      toolTipTitle={
                        contentFilterText !== ""
                          ? `「${contentFilterText}」で絞り込んでいます`
                          : `検索結果をフィルター(ファイル名)`
                      }
                      initialText={contentFilterText}
                      handleChange={contentFilterHandleSubmit}
                      className={classes.rightContentFilterPaneInput}
                    />
                    {!vfContext.openSearchConditionDrawer && (
                      <div className={classes.rightContentFilterPaneOpener}>
                        <Delayed waitBeforeShow={100}>
                          <Fade in>
                            <div className={classes.searchPaneRight}>
                              <Button
                                size="small"
                                className={classes.openButton}
                                onClick={() => {
                                  if (vfDispatch) {
                                    vfDispatch({
                                      type: VirtualFolderActionType.UPDATE,
                                      payload: {
                                        ...vfContext,
                                        openSearchConditionDrawer: true,
                                      },
                                    });
                                  }
                                }}
                              >
                                検索条件を指定する
                              </Button>
                            </div>
                          </Fade>
                        </Delayed>
                      </div>
                    )}
                  </div>
                  {/* Info (パンくずリスト、件数) */}
                  <div className={classes.rightInfoPane}>
                    <VirtualFolderInfoPane
                      path={breadcrumbs.path}
                      configId={breadcrumbs.configId}
                      excludes={breadcrumbs.excludes}
                      count={documentItems?.total_info.value || 0}
                      onClick={handleClickBreadcrumbs}
                    />
                  </div>
                  {/* 同義語編集コンポーネント（パンくずリスト下） */}
                  <div className={classes.synonym}>
                    <VirtualFolderSynonymEditableWrapper
                      context={vfContext}
                      dispatch={vfDispatch}
                    />
                  </div>
                  {/* [HP稼働]: electronからの修正(不要処理削除) */}
                  {/* Display Options (表示形式) */}
                  {/* <div className={classes.rightDisplayOptionPane}>
                    <VirtualFolderDisplayOptionPane
                      displayMode={contentDisplayMode}
                      handleDisplayModeChange={handleContentDisplayModeChange}
                      sortTypeData={sortTypeData}
                      handleSortChange={handleSortChange}
                    />
                  </div> */}
                  {/* Content */}
                  <div>{contentPane}</div>
                </div>
              </SplitPane>
            </div>
            <div className={classes.bodyDrawer}>
              <SearchConditionDrawer
                open={vfContext.openSearchConditionDrawer}
                userGroupDefs={userGroupDefsState}
                data={conditions.conditions}
                onChange={handleConditionChange}
                onClose={() => {
                  if (vfDispatch) {
                    vfDispatch({
                      type: VirtualFolderActionType.UPDATE,
                      payload: {
                        ...vfContext,
                        openSearchConditionDrawer: false,
                      },
                    });
                  }
                }}
              />
            </div>
          </div>
        </PageBodyDiv>
      </div>
      <AlertDialog
        data={alertDialogData}
        handleClose={() => {
          setAlertDialogData((prevState: AlertDialogData) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <ScrollDialog
        open={previewDialogData.open}
        scroll="paper"
        title={previewDialogData.title}
        subtitle={(
          <div style={{ margin: "-1rem 1rem 0.5rem 1rem" }}>
            <VirtualFolderSynonymEditableWrapper
              context={vfContext}
              dispatch={vfDispatch}
            />
          </div>
        )}
        content={(
          <KeywordHighlighter
            content={previewDialogData.content}
            configs={SearchKeywordHelper.getKeywordHighlightConfigs(
              vfContext.editableSearchKeywords,
              getColor
            )}
            highlight
          />
        )}
        handleClose={() => {
          setPreviewDialogData({
            ...previewDialogData,
            open: false,
          });
        }}
      />
      <DetailFileInfoDialog
        open={openDetailFileInfoDialog}
        onClose={handleDetailFileInfoDialogClose}
        scroll="paper"
        detailFileInfoDialogState={detailFileInfoDialogState}
        onOpenPreviewDialog={handleOpenPreviewDialog}
      // [HP稼働]: electronからの修正(不要処理削除)
      // onOpenPath={handleOpenPath}
      // onShowItemInFolder={handleShowItemInFolder}
      // onSTSearch={handleSTSearch}
      />
    </div>
  );
}
